import { createClient } from '@supabase/supabase-js';
import { decodeJwtParts, getHostnameFromUrl, safeTokenPreview } from './debug/jwtDebug';

// Get environment variables
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;

// Check for valid values
if (!supabaseUrl || supabaseUrl === 'your_supabase_url' || 
    !supabaseAnonKey || supabaseAnonKey === 'your_supabase_anon_key') {
  console.error('Invalid Supabase credentials. Please check your environment variables.');
}

// Create client with proper error handling
let supabase;
try {
  supabase = createClient(supabaseUrl, supabaseAnonKey);
} catch (error) {
  console.error('Error initializing Supabase client:', error);
  // Provide a dummy client or fallback
  supabase = {
    auth: {
      getSession: () => Promise.resolve({ data: { session: null } }),
      signUp: () => Promise.resolve({ data: { user: { id: 'local-fallback-id' } } }),
    },
    from: () => ({
      select: () => ({ eq: () => ({ single: () => Promise.resolve({ data: null }) }) }),
      insert: () => Promise.resolve({ error: null }),
      update: () => Promise.resolve({ error: null }),
    }),
  };
}

// Dev-only diagnostics: help catch key/url mismatch and key type issues.
if (process.env.NODE_ENV !== 'production') {
  try {
    const host = supabaseUrl ? getHostnameFromUrl(supabaseUrl) : null;
    const jwtAnonKey = process.env.REACT_APP_SUPABASE_JWT_ANON_KEY;
    const keyType = typeof supabaseAnonKey === 'string' && supabaseAnonKey.startsWith('sb_')
      ? 'publishable_or_service_like'
      : 'jwt_or_unknown';
    const decoded = decodeJwtParts(supabaseAnonKey);
    const anonIss = decoded?.payload?.iss || null;
    const anonIssHost = anonIss ? getHostnameFromUrl(anonIss) : null;

    console.log('[supabaseClient] env debug', {
      supabaseHost: host,
      anonKeyFromREACT_APP_SUPABASE_ANON_KEY: safeTokenPreview(supabaseAnonKey),
      jwtAnonKeyFromREACT_APP_SUPABASE_JWT_ANON_KEY: safeTokenPreview(jwtAnonKey),
      anonKeyType: keyType,
      anonKeyPartsCount: decoded?.partsCount,
      anonKeyIss: anonIss,
      anonKeyIssHost: anonIssHost,
      anonKeyProjectMismatch: Boolean(host && anonIssHost) && host !== anonIssHost,
    });
  } catch {
    // ignore
  }
}

export { supabase };